<script>
  import { Router, Route } from "svelte-routing";
  import { modalStore, panelController, modalS } from "./stores/service";
  import { loginService, inicializarvistas } from "./Controller/user/Login";
  import { paneListMesasConfig } from "./Controller/apps/paneListMesas/dataConfig";
 
  import Beta from "./views/Beta.svelte";
  import { writable, get } from "svelte/store";

  import MainSidebar from "./components/user/Sidebar/MainSidebar.svelte";
  import ContentHeader from "./components/user/content-wrapper/ContentHeader.svelte";

  import PageError from "./views/PageError.svelte";
  import Footer from "./components/user/Footer/Footer.svelte";
  import Load from "./components/Alert/Load.svelte";

  import { onMount } from "svelte";
  import { user, readServices } from "./stores/user";
  import Navdar from "./components/user/Navdar/Navdar.svelte";

  import Login from "./views/Login.svelte";
  /* import Login from "./views/user/menu/menu.svelte"; */
  import CES from "./views/admin/CES.svelte";
  import Panel from "./views/admin/Panel-Menu.svelte";/* 
  import MainR from "./views/admin/Panel-Ratinggs.svelte"; */
  import MainAnalytics from "./views/admin/analytics/menu/routeAnalytics.svelte";
  import Dashboard from "./views/admin/Dashboard.svelte";
  import SondeosPanel from "./views/admin/SondeosPanel.svelte";
  /*  import configAdmin from "./views/admin/config.svelte"; */
  import Config from "./views/admin/Configuracion.svelte";
  import Orden from "./views/admin/Ordenar.svelte";
  import Politicas from "./views/politicas.svelte";
  import PerfilUser from "./views/Perfil.svelte";
  import UserPanel from "./views/user/Perfil.svelte";

  /*  
  import Evaluacion from "./views/user/Evaluacion.svelte";
  import Pedido from "./views/user/servicioMesa.svelte";
  import End from "./views/user/endService.svelte"; 
  */

  import Evaluacion from "./views/user/cliente/menu_de_servicio/Evaluacion.svelte";
  import Pedido from "./views/user/cliente/menu_de_servicio/servicioMesa.svelte";
  import End from "./views/user/cliente/menu_de_servicio/endService.svelte";

  import { navigate } from "svelte-routing/src/history";
  import EditRaitingg from "./views/admin/EditRaitingg.svelte";
  import Membresia from "./views/root/Membresia.svelte";

  import Mesas from "./views/admin/rest/mesas.svelte";
  import MenuConfig from "./views/admin/config/RouteConfig.svelte";
  /* import MenuConfig from "./views/admin/Configuracion.svelte"; */

  onMount(() => {
   
    const urlParams = new URLSearchParams(window.location.search);
    $panelController.viewLogin.url.id = urlParams.get("id");
    $panelController.viewLogin.url.key = urlParams.get("key");
    $panelController.viewLogin.url.nmesa = urlParams.get("idmesa");

    if (
      $panelController.viewLogin.url.key &&
      $panelController.viewLogin.url.id
    ) {
      $panelController.firebase.load = true;
      $panelController.viewLogin.roluser = 3; /* Reemplazar */
      $panelController.viewLogin.user = "muestra";

      $panelController.viewLogin.status = true;
      
      navigate("/", { replace: true });
    } else {
      /* indefinido */
      UserValid();
    }
  });


  async function UserValid() {
    let resp = await user.current();

    if ($user) {
      $panelController.viewLogin.user = "user";
      loginService({
        email: $user.email,
        photoURL: $user.photoURL,
        displayName: $user.displayName,
      });
    } else {
      $panelController.viewLogin.user = "login";
      inicializarvistas($panelController.viewLogin.user);
    }
  }


  $: {
    try {
      console.log("panelController", $panelController);
      /*  console.log("modalS", $modalS);  */
      /*  console.log(window.navigator.onLine); */
    } catch (error) {
      /* enviar error */
      /* console.log(' system -->',error); */
    }

    switch ($modalStore.opc) {
      case 404:
        window.location.reload();
        break;

      default:
        break;
    }
  }

  
</script>

<!-- verificar que no este habilitado databarealtime -->

<!-- si esta desabilitado tenemos que realizar una lectura para actualizar el componente y su data-->

<body class="hold-transition sidebar-mini sidebar-collapse">
  <!-- Site wrapper -->
  <div class="wrapper">
    <!-- Navbar -->
    <Navdar />
    <!-- /.navbar -->
    <!-- Main Sidebar Container -->
    <MainSidebar />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper" class:no-sidebar={!$panelController.viewLogin.nav}>
      <!-- Content Header (Page header) -->
      <ContentHeader />                               
      <!-- Main content -->
      <section class="content">
        <div class="container-fluid">
          {#if !$panelController.firebase.load}
            <Load />
          {:else}
            <Router>
              <Route path="/" component={Login} />
              <Route path="/perfilUser">
                <PerfilUser />
              </Route>
              <Route path="/politicas">
                <Politicas />
              </Route>
              <Route path="/config/*">
                <MenuConfig />
              </Route>
              <Route path="/beta">
                <Beta />
              </Route>
              <Route path="/final">
                <End />
              </Route>
              {#if $panelController.viewLogin.roluser === 1}
                <Route path="/CE">
                  <CES />
                </Route>
                <Route path="/EditRatingg">
                  <EditRaitingg />
                </Route>
                <Route path="/evaluacion">
                  <Evaluacion />
                </Route>
                <Route path="/panel">
                  <Panel />
                </Route>
                <!-- <Route path="/main-ratinggs">
                  <MainR />
                </Route> -->
                <Route path="/MainAnalytics/*">
                  <MainAnalytics />
                </Route>
                <Route path="/orden">
                  <Orden />
                </Route>
                <Route path="/membresias">
                  <Membresia />
                </Route>

                <Route path="/mesas" component={Mesas} />

                <Route path="/dashboard">
                  <Dashboard />
                </Route>
                <Route path="/sondeosPanel">
                  <SondeosPanel />
                </Route>

                <Route path="/user">
                  <UserPanel />
                </Route>
              {/if}
              {#if $panelController.viewLogin.roluser == 1 || $panelController.viewLogin.roluser == 3}
                <Route path="/pedido">
                  <Pedido />
                </Route>

                <Route path="/evaluacion">
                  <Evaluacion />
                </Route>
              {/if}
            </Router>
          {/if}

          <div class="toast-container position-fixed bottom-0 end-0 p-3">
            {#each $panelController.notificaciones.ToastList as data}
              <div
                bind:this={data.data.show}
                id="liveToast"
                class="toast"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div class="toast-header">
                  <img
                    src={data.data.img}
                    class="rounded me-2"
                    style=" width: 25px; height: 25px;"
                    alt="..."
                  />
                  <strong class="me-auto">{data.data.title}</strong>

                  <small>{data.data.time}</small>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="toast-body">
                  {data.data.body}
                </div>
              </div>
            {/each}
          </div>
        </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
    <Footer />
    <!-- Control Sidebar -->
    <aside class="control-sidebar control-sidebar-dark">
      <!-- Control sidebar content goes here -->
    </aside>
    <!-- /.control-sidebar -->
  </div>
  <!-- ./wrapper -->
</body>
{#if $modalStore.open}
  <div
    class="modal"
    id="sampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="sampleModalLabel"
    aria-hidden={false}
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sampleModalLabel">{$modalStore.title}</h5>

          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            on:click={() => ($modalStore.open = false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">{$modalStore.body}</div>
        {#if $modalStore.form.active}
          <form action="">
            <input
              class="form-control"
              type="text"
              placeholder={$modalStore.form.placeholder}
              aria-label="default input example"
              bind:value={$modalStore.form.value}
            />
          </form>
        {/if}
        <div class="modal-footer">
          {#if $modalStore.mess}
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              on:click={() => ($modalStore.ans = false)}
              on:click={() => ($modalStore.open = false)}
              >{$modalStore.opcN}</button
            >
          {/if}

          <button
            type="button"
            class="btn btn-primary"
            on:click={() => ($modalStore.ans = true)}
            on:click={() => ($modalStore.open = false)}
            >{$modalStore.opcS}</button
          >
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop show" />
{/if}

{#if $modalS.status}
  <div
    class="modal"
    id="sampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="sampleModalLabel"
    aria-hidden={false}
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sampleModalLabel">
            {$modalS.info.title}
          </h5>
          {#if $modalS.controllers.btnClose}
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              on:click={() => ($modalS.status = false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          {/if}
        </div>
        <div class="modal-body">{$modalS.info.body}</div>
        {#if $modalS.controllers.input.status}
          <form action="">
            <input
              class="form-control"
              type="text"
              placeholder={$modalS.controllers.input.placeholder}
              aria-label="default input example"
              bind:value={$modalS.controllers.input.value}
            />
          </form>
          <label for="input">{$modalS.controllers.input.label}</label>
        {/if}
        <div class="modal-footer">
          {#each $modalS.controllers.btn as btn}
            {#if btn.status}
              <button
                type="button"
                class="btn {btn.style}"
                data-dismiss="modal"
                on:click={() => $modalS.confirmar(btn.value)}>{btn.text}</button
              >
            {/if}
          {/each}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop show" />
{/if}

<!-- on:click={()=>$modalS.value = btn.value} -->
<style>
  .modal {
    display: block;
  }

  body.sidebar-mini.sidebar-collapse .content-wrapper.no-sidebar {
    margin-left: 0 !important;
    background: #fbf6ea;
  }
</style>
